export default {
  GET_CHARACTER: state => state.character,
  GET_UNITS: state => state.units,
}
